import {
	LaravelResponse,
	PaginatedListFetcherConfig,
	keyToUrl,
	mapPaginatedFetcherConfigToAxiosConfig,
	withDestroyEndpoint,
	withShowEndpoint,
	withStoreEndpoint,
	withUpdateEndpoint,
} from "@dgs/core";
import axios from "axios";
import {
	AppNotificationIndexResource,
	AppNotificationRequest,
	AppNotificationUpdateResource,
} from "../types/appNotification";

const baseKey = ["app", "notifications"];
const indexKey = [...baseKey, "filtered"];

const appNotificationServiceCrudService = {
	...withShowEndpoint<AppNotificationUpdateResource>(baseKey),
	...withStoreEndpoint<AppNotificationRequest, AppNotificationIndexResource>(baseKey),
	...withUpdateEndpoint<AppNotificationRequest>(baseKey),
	...withDestroyEndpoint(baseKey),
};

export const appNotificationService = {
	...appNotificationServiceCrudService,
	index: (config: PaginatedListFetcherConfig<AppNotificationIndexResource>) => {
		return axios.put<LaravelResponse<AppNotificationIndexResource[]>>(
			keyToUrl(indexKey),
			{ filters: config.filterParams, sort: config.sortParams },
			mapPaginatedFetcherConfigToAxiosConfig(config),
		);
	},
	indexKey,
	listKey: [...indexKey, "list"],
};
